import { MenuOutlined } from '@ant-design/icons'
import { Button, Dropdown, MenuProps, message, Popconfirm } from 'antd'
import React, { FunctionComponent, useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'

import { useDeletePropertyListMutation } from '../../../graphql/generated'
import { clickTrigger } from '../../utils/layoutConst'
import { propertyListDetailPath } from '../../utils/paths'
import { PropertyListEditModalButton } from '../PropertyListEditModalButton/PropertyListEditModalButton'
import { PropertyListTableItem } from '../PropertyListTable/PropertyListTable'

export interface PropertyListTableActionProps {
  refetch?: () => void
  record: PropertyListTableItem
}

export const PropertyListTableAction: FunctionComponent<PropertyListTableActionProps> =
  props => {
    const [, deleteList] = useDeletePropertyListMutation()

    const handleDelete = useCallback(() => {
      deleteList({ id: props.record.id, deletedAt: new Date() })
        .then(() => message.success('Seznam byl smazán.'))
        .catch(() => message.error('Seznam se nepodařilo smazat.'))
    }, [deleteList, props.record.id])

    const menuProps = useMemo<MenuProps>(
      () => ({
        items: [
          {
            key: 'edit',
            className: '!p-0',
            label: <PropertyListEditModalButton record={props.record} />,
          },
          {
            key: 'delete',
            className: '!p-0',
            label: (
              <Popconfirm
                title={`Opravdu chcete smazat seznam "${props.record.name}"?`}
                placement="topRight"
                onConfirm={handleDelete}
                okText="Smazat seznam"
                okType="danger"
                okButtonProps={{ danger: true }}
                cancelText="Zrušit"
              >
                <Button type="link" danger className="w-full !text-left">
                  Smazat
                </Button>
              </Popconfirm>
            ),
          },
        ],
      }),
      [handleDelete, props.record]
    )

    return (
      <Dropdown.Button
        icon={<MenuOutlined />}
        menu={menuProps}
        arrow
        type="link"
        size="small"
        trigger={clickTrigger}
      >
        <Link to={propertyListDetailPath(props.record.id)}>
          Zobrazit detail
        </Link>
      </Dropdown.Button>
    )
  }
